export default __webpack_public_path__ + "static/media/3_size_type03_unselected_icon.8900a403.jpg";